import { Box, Flex } from "@chakra-ui/react";
import { MotionBox, staggeredAppear, viewAppearDefault, appearBelow } from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";
import Image from "components/base/Image";

const Card = ({ image, title, description }) => (
  <MotionBox variants={viewAppearDefault} height="100%">
    <Image
      src={image}
      alt={title}
      minHeight="380px"
      objectFit="cover"
      objectPosition="top"
    />
    <Box pt={["sm", null, "lg"]}>
      <Text
        type="title_md"
        color="white"
        pb="12px"
        minH={["24px", null, "56px"]}
      >
        {title}
      </Text>
      <Text type="p_md" color="white">
        {description}
      </Text>
    </Box>
  </MotionBox>
);

export default function CareerPathwaysSection({ bg, title, items }) {
  return (
    <Box bg={bg || "black.900"} width="100%" height="100%" px={[6, null, 20]}>
      <Container px={0}>
        <MotionBox
          variants={appearBelow}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          mb={[8, null, 12]}
        >
          <Text type="headline_md" color="white" mb={[8, null, 12]}>
            {title}
          </Text>
        </MotionBox>
        <MotionBox
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <Flex
            direction={["column", null, null, "row"]}
            gap={["xxl", null, null, 8]}
          >
            {items.map((item) => (
              <Card
                key={item.image}
                image={item.image}
                title={item.title}
                description={item.description}
              />
            ))}
          </Flex>
        </MotionBox>
      </Container>
    </Box>
  );
}
